export default {"src":"/_next/static/media/multiplication.2e508a4d.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};